import React, { useState, useEffect ,useRef} from "react";
import { Form, Card, Container, Row, Col } from "react-bootstrap";
import { FaChevronDown,FaChevronUp } from "react-icons/fa";

const CustomDropdown = ({ actions }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const ref = useRef(null);

  const handleToggleDropdown = () => setIsOpen(!isOpen);

  const handleSelectOption = action => {
    console.log("Selected Option: ", action);
    action.onClick();
    setIsOpen(false); // Close dropdown after selection
  };
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    
    if (isOpen) {
      // Attach the listener only if the dropdown is open
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      // Remove the event listener
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]); 

  return (
    <div className="custom-dropdown" ref={ref}>
      <div className="dropdown-selected" onClick={handleToggleDropdown} >
        {selectedOption || "Select an Option"}
       {
          isOpen ? <FaChevronUp className="dropdown-icon"/> : <FaChevronDown className="dropdown-icon"/>
       }
      </div>
      {isOpen && (
        <div className={`dropdown-content ${isOpen ? "" : "display-none"}`}>
          {actions
            .filter(action => !action.isHide)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((action, index) => (
              <div
                key={index}
                className="custom-card"
                onClick={() => handleSelectOption(action)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column" // Example layout
                }}
              >
                <p className="custom-card-text"> {`${index + 1}. ${action.name}`}</p>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

const SelectActions = ({ actions }) => {
  const [action, setAction] = useState("");

  useEffect(() => {
    if (action) {
      let selectedOption = actions.find(actionOption => actionOption.name === action);
      selectedOption?.onClick();
      setAction("");
    }
  }, [action, actions]);

  return (
    <>
      <Card style={{ height: "150px" }} className="cardRounded">
        <Card.Header className="cardHeader">Select Action</Card.Header>
        <Card.Body className="cardBody">
          <CustomDropdown actions={actions} />

          {/* <Form.Group>
            <Form.Select
              id="formSelect"
              value={action}
              onChange={e => {
                setAction(e.target.value);
              }}
              className="action-select"
            >
              <option value="" default disabled className="action-select-option">
                Select Action
              </option>
              {actions
                .filter(action => action?.isHide !== true)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((action, index) => (
                  <option
                    className="action-select-option"
                    key={action.name}
                    disabled={action?.isDisabled || false}
                    value={action.name}
                    style={{
                      marginBottom: "200px",
                      marginTop: "20px",
                      fontSize: "20px"
                    }}
                  >
                    {`${index + 1}. ${action.name}`}
                  </option>
                ))}
            </Form.Select>
          </Form.Group> */}
        </Card.Body>
      </Card>
    </>
  );
};

export default SelectActions;
